import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { updateSite } from '../actions/sites';
import { getCaseSiteById } from '../reducers/sites';
import {
  getAllWorkers,
  getAllContacts,
  getAllProducts,
  getAllUnits,
  getCaseNewStatus,
  getAllSecurityEpis,
  getAllInventoryToPlan,
} from '../reducers/requirements';
import { fetchContacts } from '../actions/requirements';
import { fetchDiagnostic, serializeDiagnostic } from '../actions/diagnostic';
import {
  getIsFetching,
  getContent,
  getMustSerialize,
} from '../reducers/diagnostic';
import { addTool, updateTool, deleteTool } from '../actions/tools';
import { getTools } from '../reducers/tools';
import { getSiteErrors, getDiagnosticErrors } from '../reducers/errors';
import SiteContact from '../components/SiteContact';
import SiteForm from '../components/SiteForm';

const mapStateToProps = (state, { params: { id } }) => ({
  site: getCaseSiteById(state, id),
  workers: getAllWorkers(state),
  contacts: getAllContacts(state),
  errors: getSiteErrors(state, id).map(e => e.field),
  products: getAllProducts(state),
  units: getAllUnits(state),
  securityEpis: getAllSecurityEpis(state),
  inventoryToPlan: getAllInventoryToPlan(state),
  isFetchingDiagnostic: getIsFetching(state, id),
  mustSerializeDiagnostic: getMustSerialize(state, id),
  diagnosticContent: getContent(state, id),
  diagnosticTools: getTools(state, id),
  diagnosticErrors: getDiagnosticErrors(state, id),
  isNewCase: getCaseNewStatus(state),
});
const mapDispatchToProps = (dispatch, { siteCase, params: { id } }) => ({
  updateSite: (site, values) => dispatch(updateSite(site, values)),
  fetchContacts: customer => dispatch(fetchContacts(customer)),
  fetchDiagnostic: type => dispatch(fetchDiagnostic(siteCase, type, id)),
  serializeDiagnostic: (type, form, hasChanges) =>
    dispatch(serializeDiagnostic(type, id, form, hasChanges)),
  addTool: type => dispatch(addTool(type, id)),
  updateTool: (type, tool, values) =>
    dispatch(updateTool(type, id, tool, values)),
  deleteTool: (type, tool) => dispatch(deleteTool(type, id, tool)),
});

const SitePage = ({
  site,
  workers,
  errors,
  updateSite,
  contacts,
  customer,
  fetchContacts,
  ...rest
}) => {
  if (site) {
    return (
      <div>
        <SiteContact
          site={site}
          contacts={contacts}
          onContactChange={updateSite}
          customer={customer}
          onContactAdded={fetchContacts}
        />
        <SiteForm
          site={site}
          workers={workers}
          errors={errors}
          onUpdate={updateSite}
          {...rest}
        />
      </div>
    );
  }

  return null;
};

SitePage.propTypes = {
  site: PropTypes.object,
  workers: PropTypes.array.isRequired,
  contacts: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  updateSite: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SitePage);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/pages/SitePage.js